import Vue from "vue";
import App from "./App.vue";
import { router } from "./router";
import { store } from "./store";
import vuetify from "./plugins/vuetify";
import * as VueGoogleMaps from "vue2-google-maps";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faWind } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import VueSession from "vue-session";
import Vuelidate from "vuelidate";
import VueTour from 'vue-tour'

require('vue-tour/dist/vue-tour.css');

Vue.config.productionTip = false;

library.add(faWind);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_MAP_KEY,
    libraries: "places" // necessary for places input
  }
});

Vue.use(Vuelidate);
/*Vue.use(VueSession);*/
Vue.use(VueTour);

new Vue({
  render: h => h(App),
  router: router,
  store: store,
  vuetify
}).$mount("#app");
